import { RelocationLimit, IRelocationLimitsTableData } from '.';

export class RelocationLimitsTableData
    implements IRelocationLimitsTableData {

    public readonly relocationLimits: RelocationLimit[] = [];
    public promiseLoad: Promise<void> | null = null;
    public selectedRelocationLimits: RelocationLimit[] = [];
}
